import './Testimonials.scss'

export default function Testimonials() {
  // Testimonials Data
  // const testimonialsData = [
  //   {
  //     id: 1,
  //     name: "Mike Cohen",
  //     title: "Instructional Technologist at WGU",
  //     img: "/assets/icons/male-placeholder-image.jpg",
  //     icon: "/assets/logos/WGU_Logo.png",
  //     quote: "Flynn is an excellent learner, she finishes her assigned task as soon as she has all necessary materials needed.",
  //   },
  //   {
  //     id: 2,
  //     name: "Rodger Roberts, MSIT, MSCS",
  //     title: "Senior Instructor at WGU",
  //     img: "/assets/icons/male-placeholder-image.jpg",
  //     icon: "/assets/logos/WGU_Logo.png",
  //     quote: "Flynn is an excellent learner, she finishes her assigned task as soon as she has all necessary materials needed.",
  //     featured: true,
  //   },
  //   {
  //     id: 3,
  //     name: "WGU Evaluator",
  //     title: "Mobile Apps Excellence Award",
  //     img: "/assets/icons/male-placeholder-image.jpg",
  //     icon: "/assets/logos/WGU_Logo.png",
  //     quote: "The application itself is aesthetically pleasing and shows a tremendous level of detail both for functionality and in the user experience. The documentation is robust, well-organized, and shows a high level of thoughtfulness in the reflection pieces."
  //   },
  // ]

  return (
    <div className='testimonials' id='testimonials'>
      <h1>Testimonials</h1>
      <span> ================================================== </span>
      <strong> UNDER CONSTRUCTION CHECK BACK LATER </strong>
      <span> ================================================== </span>

      {/* <div className="container">
          {testimonialsData.map(t => (
          <div className={"card " + (t.featured && "featured")}>
            <div className="left">
              <div className="top">
                <img className="person"
                src={t.img} 
                alt={t.name} />
                <img className="logo"
                src={t.icon}
                alt="logo" />
              </div>
              <div className="center">
                <h3>{t.name}</h3>
                <h4>{t.title}</h4>
              </div>
            </div>
            <div className="bottom">
              <span><FormatQuoteRounded className="quotes"/>
              {t.quote}
              </span>
            </div>

          </div>
          ))}
        </div> */}
    </div>
  )
}
